import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import ACertification from '../atoms/_atoms.certification';

export default function MCertification({ items }) {
	return (
		<ul className="m-certification-list">
			{
				items.map(item => (
					<div
						key={get(item, 'alt', '')}
						className="align-wrapper"
					>
						<ACertification
							img={get(item, 'img', '')}
							alt={get(item, 'alt', '')}
						/>
					</div>
				))
			}
		</ul>
	);
}

MCertification.propTypes = {
	items: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.certification.js